import { DELETE } from 'mobx/dist/internal';
import { TOrder } from 'types/Orders/order';

export const nameCellLarge = '23.04%';
export const nameCellSmall = '12.25%';

/**
 * Ширина колонки «№» в пикселях при масштабе 100%: 3.6% от таблицы в 1000px
 * (`width: '3.6%'` в data.tsx каждой таблицы и `.table-size` в components/style.scss).
 *
 * По ней считается момент, когда колонка наименования схлопывается до узкой:
 * как только «№» уехала за левый край, места на полное наименование уже нет.
 */
export const numberCellWidth = 36;

export const topicCategory = {
    product: 'Продукт',
    service: 'Услуга',
    task: 'Задача',
};

export enum EmptyRows {
    EMPTY_ROW_1 = 'EMPTY_ROW_1',
    EMPTY_ROW_2 = 'EMPTY_ROW_2',
}

export const initialOrderData: TOrder = {
    id: null,
    crm: null,
    customer: null,
    order_object: null,
    all_required_empty_order_fields: [],
    order_fields: [],
    products: [],
    services: [],
    tasks: [],
    total_sum: 0,
    order_status: null,
    percent_of_work: null,
    start_planned_at: null,
    started_at: null,
    finish_planned_at: null,
    finished_at: null,
    unassigned_services: [],
    unassigned_tasks: [],
    // Временно
    unassigned_entities: [],
};

export const ORDER_OBJECT = 'Объект заказа (кто/что)';
